import Loadable from 'react/components/loadable';

const EditTaxRateDrawer = Loadable({
  loader: () => import('../../pages/pos/tax_rates/edit_tax_rate'),
  type: 'drawer',
});

angular.module('gym').value('EditTaxRateDrawer', EditTaxRateDrawer);
